import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'

// action types

export const PAGINATE_ALL_STANDS = "getPaginatedStands";
export const ALL_STANDS = "getAllStands";
export const CREATE_STAND_FORM = "createStandForm";
export const DELETE_STAND = "deleteStand";
export const GET_STAND_DATA = "getStandData";
export const CREATE_STAND = "createStand";
export const UPDATE_STAND = "updateStand";


// mutation types

export const SET_PAGINATED_STANDS = "setPaginatedStands";
export const SET_ALL_STANDS = "setAllStands";
export const SET_STAND_DATA = "setStandData";
export const SET_STAND_META = "setStandMeta";
export const SET_STAND_ERROR = "setStandError";
export const SET_STAND_LOADING = "setStandLoading";
export const CLEAR_STAND_ERROR = "clearStandError";
export const SET_IS_DISABLED_STAND = "setIsDisabledStand";


const state = {
    stands: [],
    paginatedStands: [],
    stand_data: {},
    meta_stand : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllStands(state) {
        return state.paginatedStands;
    },

    allStands(state) {
        return state.stands;
    },

    getStandData(state) {
        return state.stand_data;
    },

    meta_stand(state) {
        return state.meta_stand;
    },
    
};

const actions = {
 
    [PAGINATE_ALL_STANDS](context, payload) {
        context.commit(SET_IS_DISABLED_STAND, false);
        context.commit(SET_STAND_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/stands?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_STAND_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_STANDS, data);
                context.commit(SET_STAND_META, data);
                context.commit(SET_STAND_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_STAND_LOADING, false);
            context.commit(SET_STAND_ERROR, response.errors);
        });
        ;
        
    },

    [ALL_STANDS]() {
        return new Promise(resolve => {
            ApiService.get('/standsAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [CREATE_STAND_FORM](context) {
        context.commit(SET_STAND_LOADING, false);
        context.commit(SET_STAND_ERROR, false);
        context.commit(SET_IS_DISABLED_STAND, false);
    },

    [GET_STAND_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_STAND, true);
        context.commit(SET_STAND_LOADING, true);
        context.commit(CLEAR_STAND_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/stand/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_STAND_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_STAND_DATA, response.data);
                    context.commit(SET_STAND_LOADING, false);
                    context.commit(SET_IS_DISABLED_STAND, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_STAND_LOADING, false);
                context.commit(SET_STAND_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_STAND, true);
            });
        });
    },

    [CREATE_STAND](context, payload) {
        context.commit(SET_STAND_LOADING, false);
        context.commit(SET_IS_DISABLED_STAND, true);
        context.commit(CLEAR_STAND_ERROR);
        return ApiService.post("/stand/store", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_STAND_ERROR);
            }
            else{
                context.commit(SET_STAND_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "Tribün başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_STAND_ERROR);
                context.commit(SET_IS_DISABLED_STAND, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_STAND_LOADING, false);
            context.commit(SET_STAND_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_STAND, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_STAND](context, payload) {
        context.commit(SET_STAND_LOADING, true);
        context.commit(SET_IS_DISABLED_STAND, true);
        context.commit(CLEAR_STAND_ERROR);
        
        return ApiService.put(`/stand/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_STAND_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı tribün başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_STAND, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_STAND_LOADING, false);
            context.commit(SET_STAND_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_STAND, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DELETE_STAND](context, payload) {
        context.commit(SET_STAND_LOADING, true);
        context.commit(CLEAR_STAND_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/stand/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_STAND_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else {
                
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    payload.itemToDelete + " ID numaralı tribün başarıyla silinmiştir."
                );
                
                
            }
        })
        .catch(( error ) => {
            context.commit(SET_STAND_ERROR, error);
            AlertService.makeToast(
                "warning",
                "Hata!",
                error
            );
        });
        
    },

    
    
};

const mutations = {

    [SET_PAGINATED_STANDS](state, paginatedStands) {
        state.paginatedStands = paginatedStands.data;
    },

    [SET_ALL_STANDS](state, stands) {
        state.stands = stands;
    },

    [SET_STAND_DATA](state, stands_data) {
        state.stands_data = stands_data;
        state.errors = [];
    },

    [SET_STAND_META](state, meta_stand) {
        state.meta_stand = meta_stand;
    },

    [SET_STAND_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_STAND_ERROR](state) {
        state.errors = [];
    },
    
    [SET_STAND_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_STAND](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
